/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBORGANISATIONSUBCLASSIFICATION = {
    ActiveNonFinancialEntityAnfe: 'ANFE',
    DeemedCompliantFinancialInstitution: 'DCFI',
    NonParticipatingFinancialInstitution: 'NPFI',
    ExemptBeneficialOwner: 'EBO',
    ParticipatingFinancialInstitution: 'PFI',
    PassiveNonFinancialEntityPnfe: 'PNFE'
} as const;
export type GHUBORGANISATIONSUBCLASSIFICATION = typeof GHUBORGANISATIONSUBCLASSIFICATION[keyof typeof GHUBORGANISATIONSUBCLASSIFICATION];


export function GHUBORGANISATIONSUBCLASSIFICATIONFromJSON(json: any): GHUBORGANISATIONSUBCLASSIFICATION {
    return GHUBORGANISATIONSUBCLASSIFICATIONFromJSONTyped(json, false);
}

export function GHUBORGANISATIONSUBCLASSIFICATIONFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBORGANISATIONSUBCLASSIFICATION {
    return json as GHUBORGANISATIONSUBCLASSIFICATION;
}

export function GHUBORGANISATIONSUBCLASSIFICATIONToJSON(value?: GHUBORGANISATIONSUBCLASSIFICATION | null): any {
    return value as any;
}

